import { useQuery } from 'react-query';
import { constantsQueries } from '@/services/constantsService';
/**
 * Hook para obtener constantes de cancellation policies
 */
export var useCancellationPolicyConstants = function () {
    return useQuery(constantsQueries.cancellationPolicy());
};
/**
 * Hook para obtener constantes de tax
 */
export var useTaxConstants = function () {
    return useQuery(constantsQueries.tax());
};
/**
 * Hook para obtener lista de países
 */
export var useCountriesConstants = function () {
    return useQuery(constantsQueries.countries());
};
/**
 * Hook para obtener constantes extendidas de rate plans
 */
export var useRatePlanExtendedConstants = function () {
    return useQuery(constantsQueries.ratePlanExtended());
};
/**
 * Hook para obtener constantes de hotel policies
 */
export var useHotelPolicyConstants = function () {
    return useQuery(constantsQueries.hotelPolicy());
};
